<div class="value" *ngFor="let val of value">Предпросмотр недоступен</div>
<div class="value" *ngIf="!value?.length">-</div>
